<template>
	<div>
		<egranty-section-divider :text="donationTitle"/>
		<v-card-text v-if="donationAmount && currencyLoaded">
			<display-text-component
				:label="donationTitle"
				:value="formatMoneyWithCode(donationAmount, currencyCode)"
				flex="wide-titled"/>
		</v-card-text>
	</div>
</template>

<script>
import EgrantySectionDivider from "../../../genericComponents/EgrantySectionDivider";
import DisplayTextComponent from "@/view/logged/offer/components/DisplayTextComponent";
import {Numbers} from "@/utils/Numbers";

export default {
  name: "AgencyMinisterDonationReadOnlyView",
  components: {EgrantySectionDivider, DisplayTextComponent},

  mixins: [Numbers],

  props: {
    donationAmount: {},
    donationTitle: {
      type: String,
      required: true
    },
    currencyCode: {
      type: String,
      default: "PLN"
    },
    currencyLoaded: {
      type: Boolean,
      default: false
    }
  }
};

</script>

<style scoped>

</style>